<!--suppress CheckEmptyScriptTag -->
<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       x="0px"
       y="0px"
       viewBox="0 0 72 72"
       style="enable-background:new 0 0 72 72;"
       xml:space="preserve">
    <rect width="26"
          height="31"
          x="7"
          y="8"
          stroke="#796E65"
          class="stroke"
          fill="none"
          stroke-width="2"/>
    <rect width="26"
          height="19"
          x="7"
          y="45"
          stroke="#796E65"
          class="stroke"
          fill="none"
          stroke-width="2"/>
    <rect width="26"
          height="19"
          x="39"
          y="8"
          stroke="#796E65"
          class="stroke"
          fill="none"
          stroke-width="2"/>
    <rect width="26"
          height="31"
          x="39"
          y="33"
          stroke="#796E65"
          fill="none"
          class="stroke"
          stroke-width="2"/>
    <g transform="translate(46, 46) scale(1.2, 1.2)">
      <circle class="fill"
              style="fill: #796e65;"
              cx="10"
              cy="10"
              r="10"/>
      <line style="fill: none; stroke: #fff; stroke-linecap: round; stroke-linejoin: round; stroke-width:2;"
            x1="5"
            y1="10"
            x2="15"
            y2="10"/>
      <line style="fill: none; stroke: #fff; stroke-linecap: round; stroke-linejoin: round; stroke-width:2;"
            x1="10"
            y1="5"
            x2="10"
            y2="15"/>
    </g>
  </svg>
</template>

<script>
/**
 * SVG icon.
 */
export default {
  name: 'SvgAddBoard'
}
</script>
